export const ACCESS_TOKEN = "Auth-Token";
export const COOKIE_KEY = "wbpf";
